import { baseModalElements, systemInfoElements, techElements } from "@monorepo/utils/src/variables/projectsData/systemAccesses/modalElements";

export const techSection = techElements.map((item) => item.value);
export const systemSection = systemInfoElements.map((item) => item.value);
export const generalSection = baseModalElements.map((item) => item.value);
